export function map() {
  let map;
  let geocoder;
  let latlngbounds;
  let geocodedMarkers = 0;

  if ($('#event-map').length > 0) {
    $(window).on('load', function () {
      initMap();
    });
  }

  function initMap() {
    // Google Map
    let script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?language=de&region=DE&key=' + sanacorp.gmaps_api_key + '&callback=initGoogleMap';
    script.defer = true;
    script.async = true;

    document.head.appendChild(script);

    window.initGoogleMap = () => {
      var args = {
        zoom: 8,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        center: new google.maps.LatLng(48, 11),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      };

      // create map
      map = new google.maps.Map(document.getElementById('event-map'), args);
      map.markers = [];

      geocoder = new google.maps.Geocoder();
      latlngbounds = new window.google.maps.LatLngBounds()

      var $results = $('.event-item');
      $results.each(function () {
        var address = $(this).data('address');
        var id = $(this).attr('id');
        var markerIcon = $(this).data('marker');
        var markerIconSelected = $(this).data('marker-selected');
        codeAddress(address, id, markerIcon, markerIconSelected);
      });
    }
  }

  function add_marker(latlng, id, markerIcon, markerIconSelected) {
    // create marker
    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      itemId: id,
      icon: {
        url: markerIcon,
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0),
      },
      markerIcon: markerIcon,
      markerIconSelected: markerIconSelected,
    });

    latlngbounds.extend(latlng);

    marker.addListener('click', function () {
      $.each(map.markers, function (index, element) {
        this.setIcon({
          url: element.markerIcon,
          scaledSize: new google.maps.Size(50, 50),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(0, 0),
        });
        $('.event-item-container').find('#' + this.itemId).removeClass('active');
      });

      marker.setIcon({
        url: this.markerIconSelected,
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0),
      });
      let $active = $('.event-item-container').find('#' + marker.itemId);
      $active.addClass('active');
      scrollToItem($active);
    });

    map.markers.push(marker);
  }

  function codeAddress(address, id, markerIcon, markerIconSelected) {
    geocoder.geocode({'address': address}, function (results, status) {
      if (status === 'OK') {
        add_marker(results[0].geometry.location, id, markerIcon, markerIconSelected);
      } else {
        console.log('Geocode was not successful for the following reason: ' + status);
      }

      geocodedMarkers++;
      if(geocodedMarkers >= $('.event-item').length){
        centerMarker();
      }
    });
  }

  function centerMarker(){
    map.setCenter(latlngbounds.getCenter());
    map.fitBounds(latlngbounds, {bottom: 0});
  }

  const scrollToItem = (elem) => {
    var parent = $('.event-item-container');
    let scrollOffset = parent.scrollTop() + elem.offset().top - parent.offset().top;
    parent.animate({scrollTop: scrollOffset}, 500);
  }

}



// WEBPACK FOOTER //
// ./scripts/components/map.js